import SideBar from './SideBar'

export default SideBar



// WEBPACK FOOTER //
// ./src/components/SideBar/index.js